export default {
  default: {
    title: 'Widget not found',
    description:
      'The widget was not found in the widget collection. Seems one of our developers has had a few too many glasses of mead. We will fix it soon...',
    header: 'Obs...'
  },
  nextSteps: {
    title: 'Next Steps',
    description: 'Here are the next 5 steps for all batches',
    header: 'Upcoming steps'
  },
  calendar: {
    title: 'Calendar',
    description: 'Calendar',
    header: 'Calendar'
  },
  batchOverview: {
    title: 'Batch Overview',
    description: 'Overview of active and planned batches',
    header: 'Batch Overview',
    startBrewing: 'Start brewing',
    active: 'Active',
    planned: 'Planned',
    noBrews: 'No brews'
  },
  tilts: {
    title: 'Tilts',
    description: 'Tilt readings',
    header: 'Tilts'
  },
  ispindels: {
    title: 'iSpindels',
    description: 'iSpindel readings',
    header: 'iSpindels'
  },
  board: {
    empty: 'No metrics available',
    itemDefaultHeader: 'Board item title',
    itemDefaultContent: 'Board item content'
  }
};
